/**
 * @author Milton Filho
 */

export const ENQUEUE_OFFLINE_ITEM = 'offlineSync/ENQUEUE_OFFLINE_ITEM';
export const SYNC_START = 'offlineSync/SYNC_START';
export const SYNC_ITEM_SUCCESS = 'offlineSync/SYNC_ITEM_SUCCESS';
export const SYNC_BOOKING_SUCCESS = 'offlineSync/SYNC_BOOKING_SUCCESS';
export const SYNC_ITEM_FAILURE = 'offlineSync/SYNC_ITEM_FAILURE';
export const SYNC_COMPLETE = 'offlineSync/SYNC_COMPLETE';
export const CLEAR_FAILED_ITEM = 'offlineSync/CLEAR_FAILED_ITEM';
export const OFFLINE_BOOK_APPOINTMENT_ENQUEUED =
  'offlineSync/OFFLINE_BOOK_APPOINTMENT_ENQUEUED';
export const BOOKING_CONFLICTED = 'offlineSync/BOOKING_CONFLICTED';
export const DISCARD_OFFLINE_BOOKING = 'offlineSync/DISCARD_OFFLINE_BOOKING';
